import { render, staticRenderFns } from "./companytab.vue?vue&type=template&id=5e7ff3ee&scoped=true&"
import script from "./companytab.vue?vue&type=script&lang=js&"
export * from "./companytab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7ff3ee",
  null
  
)

export default component.exports